import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=51192bb5&"
import script from "./TestCard.vue?vue&type=script&lang=js&"
export * from "./TestCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports